<template>
  <main class="home hero">
    <div class="hero">
      <div class="logo">Hewvo</div>
      <h2>Global Supply Chain  Services Expert</h2>
      <p class="slogan">Provide digitally-driven global supply chain services for advanced manufacturing enterprises</p>
      <div class="stats-contain">
        <div class="stat-item strong-img">
          <div class="stat-number">{{$t("home.num1")}}</div>
          <div>{{$t("home.numTitle1")}}</div>
        </div>
        <div class="stat-item strong-img">
          <div class="stat-number">{{$t("home.num2")}}</div>
          <div>
            {{$t("home.numTitle2")}}
          </div>
        </div>
        <div class="stat-item strong-img">
          <div class="stat-number">{{$t("home.num3")}}</div>
          <div>{{$t("home.numTitle3")}}</div>
        </div>
        <div class="stat-item strong-img">
          <div class="stat-number">{{$t("home.num33")}}</div>
          <div>
            {{$t("home.numTitle33")}}
          </div>
        </div>
        <div class="stat-item strong-img">
          <div class="stat-number">{{$t("home.num4")}}</div>
          <div>
            {{$t("home.numTitle4")}}
          </div>
        </div>
        <div class="stat-item strong-img">
          <div class="stat-number">{{$t("home.num5")}}</div>
          <div>{{$t("home.numTitle5")}}</div>
        </div>
        <div class="stat-item strong-img">
          <div class="stat-number">{{$t("home.num6")}}</div>
          <div>
            {{$t("home.numTitle6")}}
          </div>
        </div>
      </div>
    </div>

    <div class="e2e-section" style="background: #fff">
      <div class="container products">
        <h2>Global Remanufacturing center</h2>
        <div class="pro-map-contain">
          <img class="map" src="@/assets/products/map_1.jpg" alt="">
          <div class="grid-data" style="padding-top: 40px">
            <div class="stats-grid">
              <div class="stat-card strong-img out-cel">
                <div class="stat-number">6</div>
                <div> Remanufacturing center</div>
              </div>
              <div class="stat-card strong-img">
                <div style="display: flex;justify-content: center;align-items: center"><span
                    class="stat-number">5</span>&nbsp;Industry
                </div>
                <div style="display: flex;justify-content: center;align-items: center"><span
                    class="stat-number">16+</span>&nbsp;Product line
                </div>
              </div>
              <div class="stat-card strong-img">
                <div class="stat-number">200w
                </div>
                <div>
                  Global total output
                </div>
              </div>
              <div class="stat-card strong-img out-cel">
                <div class="stat-number">30%+

                </div>
                <div> High-level technical talents</div>
              </div>
            </div>
          </div>
        </div>
        <div class="pic-grid">
          <div class="item">
            <img src="@/assets/products/1.png" alt="" style="border-radius: 10px;width: 130px;height: 96px;">
            <div>Factory Outside</div>
          </div>
          <div class="item">
            <img src="@/assets/products/2.png" alt="" style="border-radius: 10px;width: 130px;height: 96px;">
            <div>Factory Outside</div>
          </div>
          <div class="item">
            <img src="@/assets/products/3.png" alt="" style="border-radius: 10px;width: 130px;height: 96px;">
            <div>RF Calibration</div>
          </div>
          <div class="item">
            <img src="@/assets/products/4.png" alt="" style="border-radius: 10px;width: 130px;height: 96px;">
            <div>Repair Line</div>
          </div>
          <div class="item">
            <img src="@/assets/products/5.png" alt="" style="border-radius: 10px;width: 130px;height: 96px;">
            <div>Testing Line</div>
          </div>
          <div class="item">
            <img src="@/assets/products/6.png" alt="" style="border-radius: 10px;width: 130px;height: 96px;">
            <div>QC Line</div>
          </div>
          <div class="item">
            <img src="@/assets/products/7.png" alt="" style="border-radius: 10px;width: 130px;height: 96px;">
            <div>TP Clean Room</div>
          </div>
          <div class="item">
            <img src="@/assets/products/9.png" alt="" style="border-radius: 10px;width: 130px;height: 96px;">
            <div>Laboratory</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 第3页：服务流程 -->
    <div class="workflow-section">
      <div class="container">
        <h2>HEWVO global supply chain services</h2>
        <div class="regions-grid">
          <!-- Europe -->
          <div class="region-card">
            <!--            <div class="region-icon">🇪🇺</div>-->
            <div class="region-icon"><img :src="require('@/assets/homeMap/europe.png')" alt=""></div>
            <h3 class="region-name">Europe</h3>
          </div>

          <!-- East -->
          <div class="region-card">
            <!--            <div class="region-icon">🌏</div>-->
            <div class="region-icon"><img :src="require('@/assets/homeMap/asia.png')" alt=""></div>
            <h3 class="region-name">Southeast Asia</h3>
          </div>
          <!-- Africa -->
          <div class="region-card">
            <!--            <div class="region-icon">🌍</div>-->
            <div class="region-icon"><img :src="require('@/assets/homeMap/africa.png')" alt=""></div>
            <h3 class="region-name">Africa
            </h3>
          </div>
          <!-- China -->
          <div class="region-card">
            <div class="region-icon"><img :src="require('@/assets/homeMap/India.png')" alt=""></div>
            <h3 class="region-name">Asia-pacific Region
            </h3>
          </div>

          <!-- India -->
          <div class="region-card">
<!--            <div class="region-icon">🇮🇳</div>-->
            <div class="region-icon"><img :src="require('@/assets/homeMap/cis.png')" alt=""></div>
            <h3 class="region-name">Middle East</h3>
          </div>
          <div class="region-card">
            <!--            <div class="region-icon">✈️</div>-->
            <div class="region-icon"><img :src="require('@/assets/homeMap/north-america.png')" alt=""></div>
            <h3 class="region-name">North America</h3>
          </div>
          <div class="region-card">
<!--            <div class="region-icon">✈️</div>-->
            <div class="region-icon"><img :src="require('@/assets/homeMap/south-america.png')" alt=""></div>
            <h3 class="region-name">South America</h3>
          </div>
        </div>
      </div>
    </div>
    <div class="workflow-section" style="background: #E9F3FF">
      <div class="container">
        <h2>Our value</h2>
        <!-- 核心价值 -->
        <div class="value-grid" style="margin: 30px 0 0 0">
          <div v-for="(item, index) in values" :key="item.title" :class="'value-card item' + index">
            <div class="img strong-img">
              <img :src="item.img" alt="">
            </div>
            <p>{{ item.title }}</p>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: "home",
  computed: {
    values() {
      return  [
        {
          title: "Rapid Establishment Brand Globalization supply chain service capabilities",
          img: require('@/assets/value/11.jpg')
        },
        {
          title: "Service Capabilities that Can Be Rapidly Expanded With Business Growth",
          img: require('@/assets/value/22.jpg')
        },
        {
          title: "Whole Process Monitoring by Smart Service System",
          img: require('@/assets/value/33.jpg')
        },
        {
          title: "Transparent & Controllable Service Cost",
          img: require('@/assets/value/44.jpg')
        },
      ]
    },
    is_en() {
      return this.$t('language') === 'English'
    }
  }
}
</script>

<style lang="scss" scoped>
.products {
  width: 1200px;
  margin: 0 auto;

  .pro-map-contain {
    display: flex;
    justify-items: center;
    align-items: center;
    justify-content: center;
    margin: 50px auto;

    .map {
      //margin: 30px auto;
      display: inline-block;
      width: 700px;
      margin-right: 20px;
    }

    .grid-data {
      display: inline-block;
      width: 400px;
    }
  }

  h2 {
    text-align: center;
    //color: var(--primary-color);
    color: #000000;
    margin-bottom: 2rem;
    font-size: 40px;
    font-weight: 500;
    font-family: Inter, Tahoma, Verdana, sans-serif;
  }

  .pic-grid {
    display: grid;
    grid-template-columns: repeat(8, 1fr);
    gap: 20px;
    padding: 0 0;
    text-align: center;
    padding-bottom: 30px;

    img {
      width: 130px;
    }
  }

  /* 核心数据展示 */
  .stats-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
    gap: 2rem;
    margin: 0 0 3rem;
    padding: 0 0;
    text-align: center;
  }

  .stat-card {
    background: #fff;
    padding: 0.5rem;
    border-radius: 5px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  }

  .out-cel {
    background: #FF6B35;
    color: #fff;

    .stat-number {
      color: #fff !important;
    }
  }

  .stat-number {
    color: #FF6B35;
    font-size: 2.5rem;
    font-weight: bold;
    margin-bottom: 0.5rem;
  }

}
/* 主内容区 */
.home {
  .stats-contain{
    box-shadow: 0 2px 10px rgba(0,0,0,0.1);
    margin: 8rem 0 3rem;
    border-radius: 5px;
    display: flex;
    padding: 2rem 0;
    background: #fff;
    text-align: center;
    .stat-item:nth-child(n+1){
      flex: 1;
      border-left: 2px solid rgb(247, 242, 240);
    }
  }
  /* 核心价值模块 */
  .value-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    width: 100%;
    gap: 15px;
    margin: 30px 0;
  }
  .value-card {
    background: white;
    padding: 30px;
    border-radius: 5px;
    box-shadow: 0 5px 20px rgba(0,0,0,0.08);
    text-align: center;
    h3 {
      padding-top: 15px;
    }
    p {
      padding-top: 10px;
      color: #000;
      font-size: 16px;
      font-weight: 500;
      font-family: Inter, Tahoma, Verdana, sans-serif;
    }
    .img {
      width: 220px;
      height: 220px;
      text-align: center;
      overflow: hidden;
      position: relative;
      margin: 0 auto;
    }
    &.item0 {
      img {
        width: 122%;
        height: 110%;
        position: absolute;
        top: -3%;
        left: -11%;
      }
    }
    &.item1 {
      img {
        width: 131%;
        height: 106%;
        position: absolute;
        top: -3%;
        left: -18%;
      }
    }
    &.item2 {
      img {
        width: 104%;
        height: 95%;
        position: absolute;
        top: -1%;
        left: -2%;
      }
    }
    &.item3 {
      img {
        width: 119%;
        height: 105%;
        position: absolute;
        top: -1%;
        left: -2%;
      }
    }
    img {
      //width: 100%;
      border: 0;
      object-fit: fill;
    }
  }
  .value-card:hover{
    transform: translateY(-8px);
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
  }
  .map-wrapper {
    position: relative;
    padding-top: 80px;
    padding-bottom: 20px;
    margin-bottom: 30px;
    display: flex;
    width: 1200px;
    .tuli {
      width: 115px;
      position: absolute;
      left: 100px;
      bottom: 40px;
    }
  }
  .regions-grid {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    gap: 25px;
    margin-top: 40px;
  }

  .region-card {
    background: #E9F3FF;
    border-radius: 5px;
    padding: 20px;
    text-align: center;
    transition: all 0.3s ease;
    border: 1px solid rgba(255, 255, 255, 0.1);
  }

  .region-card:hover {
    transform: translateY(-8px);
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
  }

  .region-icon {
    font-size: 2.8rem;
    margin-bottom: 10px;
    color: #FF6B35;
    img{
      width: 60px;
      height: 60px;
    }
  }

  .region-name {
    font-size: 16px;
    font-weight: 500;
    //margin-bottom: 15px;
    color: #000;
    font-family: Inter, Tahoma, Verdana, sans-serif;

  }

  .region-desc {
    font-size: 1rem;
    color: #a8c7eb;
    line-height: 1.6;
  }


  .process-steps {
    margin: 0 auto;
    text-align: center;
    display: flex;
    flex-direction: column;
    width: 350px;
  }

  .process-step + .process-step {
    .step-content{
      border-top: 1px solid #ececec;
    }
  }
  .process-step {
    display: flex;
    align-items: flex-start;
    gap: 20px;
    .step-marker {
      background: rgb(193,42,102);
      color: white;
      width: 20px;
      height: 20px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: bold;
      flex-shrink: 0;
      margin-top: 4px;
      font-size: 0.8rem;
    }

    .step-content {
      background: white;
      border-radius: 0 8px 8px 0;
      box-shadow: 0 3px 10px rgba(0,0,0,0.05);
      flex-grow: 1;

      p {
        margin: 0;
        line-height: 1.6;
        color: #333;
        font-size: 12px;
        text-align: left;

        strong {
          color: #004E7C;
        }
      }
    }
  }

  .process-cycle {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 1rem;
    margin-top: 3rem;
    padding: 1.5rem;
    background: #e6f4ff;
    border-radius: 8px;
    max-width: 600px;
    margin: 3rem auto 0;

    .cycle-icon {
      font-size: 2rem;
      flex-shrink: 0;
    }

    .cycle-text {
      margin: 0;
      font-size: 1.1rem;
      color: #0066a6;
      font-weight: 500;
    }
  }

  //.map {
  //  display: block;
  //  width: 800px;
  //  margin-right: 20px;
  //  padding-right: 20px;
  //  border-right: 1px dotted #bdbdbd;
  //}
  /* E2E解决方案样式 */
  .e2e-section {
    padding: 5rem 0;
    background: #E9F3FF;

    .container {
      max-width: 1200px;
      margin: 0 auto;
      padding: 0 2rem;
    }

    h2 {
      text-align: center;
      //color: var(--primary-color);
      color: #000000;
      margin-bottom: 1.5rem;
      font-size: 40px;
      font-family: Inter, Tahoma, Verdana, sans-serif;
    }

    .e2e-description {
      text-align: center;
      font-size: 22px;
      line-height: 33px;
      max-width: 900px;
      margin: 0 auto 3rem;
      color: #000;
      font-family: Inter, Tahoma, Verdana, sans-serif;
    }

    .solution-structure {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-wrap: wrap;
      gap: 2rem;
      font-family: Inter, Tahoma, Verdana, sans-serif;
      .solution-phase {
        border-radius: 5px;
        padding: 2rem;
        box-shadow: 0 5px 15px rgba(0,0,0,0.1);
        flex: 1;
        width: 300px;
        height: 220px;
        h3 {
          color: #fff;
          margin-bottom: 1rem;
          text-align: center;
          font-size: 24px;
          font-weight: 500;
        }

        ul {
          list-style: none;
          padding: 0;
          color: #fff;
          li {
            padding: 0.7rem 0;
            border-bottom: 1px solid #eee;
            text-align: center;
            font-size: 1.1rem;

            &:last-child {
              border-bottom: none;
            }
          }
        }
      }

      .solution-arrow {
        font-size: 2rem;
        color: #004E7C;
        font-weight: bold;
      }
    }

    .benefits-grid {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
      gap: 2rem;

      .benefit-card {
        background: white;
        border-radius: 10px;
        padding: 2rem;
        text-align: center;
        box-shadow: 0 5px 15px rgba(0,0,0,0.05);
        transition: transform 0.3s ease;

        &:hover {
          transform: translateY(-5px);
        }

        .benefit-icon {
          font-size: 3rem;
          margin-bottom: 1rem;
        }

        h4 {
          color: #004E7C;
          margin-bottom: 1rem;
        }

        p {
          color: #666;
          line-height: 1.6;
        }
      }
    }
  }

  /* 服务流程样式 */
  .workflow-section {
    padding: 5rem 0;
    background: white;

    .container {
      max-width: 1200px;
      margin: 0 auto;
      padding: 0 2rem;
    }

    h2 {
      text-align: center;
      //color: var(--primary-color);
      color: #000000;
      margin-bottom: 3rem;
      font-size: 40px;
      font-family: Inter, Tahoma, Verdana, sans-serif;
    }

  }


  .hero {
    background: linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.3)), url('../assets/home3.jpg');
    background-size: cover;
    padding:10rem 3% 1rem 3%;
    text-align: left;
  }
  h2 {
    font-size: 2rem;
    color: #ffffff;
    font-weight: 400;
  }
  .slogan {
    padding-top: 20px;
    font-size: 1.5rem;
    color: #ffffff;
  }

  /* 企业标志 */
  .logo {
    color: #FF6B35;
    font-size: 4.5rem;
    font-weight: bold;
    margin-bottom: 1rem;
    padding-top: 40px;
  }

  ///* 核心数据展示 */
  //.stats-grid {
  //  display: grid;
  //  grid-template-columns: repeat(7, 1fr);
  //  gap: 1.5rem;
  //  margin: 8rem 0 3rem;
  //  //padding: 3rem 0;
  //}
  .stat-number {
    color: #FF6B35;
    font-size: 2rem;
    font-weight: bold;
    margin-bottom: 0.5rem;
  }

  /* 业务领域标签 */
  .business-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;
    justify-content: center;
    margin: 2rem 0;
  }
  .tag {
    background: #004E7C;
    color: white;
    padding: 0.5rem 1.2rem;
    border-radius: 20px;
    font-size: 0.9rem;
  }

  /* 响应式调整 */
  @media (max-width: 768px) {
    .e2e-section {
      .container {
        max-width: 100%;
        box-sizing: border-box;
      }
    }
    .stats-contain {
      display: block;
    }
    .hero {
      width: 100%;
      box-sizing: border-box;
    }
    .workflow-section .container {
      width: 100%;
      box-sizing: border-box;
      .regions-grid {
        grid-template-columns: repeat(1, 1fr);
      }
      .value-grid {
        grid-template-columns: repeat(1, 1fr);
      }
    }


    .map-wrapper {
      width: 100%;
    }

    .logo {
      font-size: 2.5rem;
    }
    .nav-links {
      gap: 1rem;
      font-size: 0.9rem;
    }
    .stat-number {
      font-size: 2rem;
    }
    .solution-structure {
      flex-direction: column !important;

      .solution-arrow {
        transform: rotate(90deg);
        margin: 1rem 0;
      }
    }
    .workflow-section::before {
      left: 40px !important;
    }
  }
}
/* 响应式设计 */
@media (max-width: 768px) {
  .products {
    width: 100%;
  }
  .navbar {
    padding: 1rem 5%;
  }
  .brand {
    font-size: 1.8rem;
  }
  .nav-links {
    gap: 1.5rem;
  }
  .services-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
    margin: 0 auto;
    justify-content: center;
    text-align: center;
    .service-card {
      width: 150px;
      height: 300px!important;
      display: block;
      margin: 0 auto;
      .service-title {
        height: 80px;
      }
    }
  }
  .service-desc {
    word-break: break-word;
  }
  .products  .pic-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 25px;
  }
  .products .pro-map-contain .map {
    width: 100%;
    margin-right: 0;
  }
  .products .pro-map-contain {
    display: block;
  }
  .products .pro-map-contain .grid-data {
    display: block;
    margin: 0 auto;
    width: auto;
  }
  .stats-grid {
    margin: 0 auto;
  }
}

</style>
